import React, { Component } from 'react';
import { connect } from "react-redux";

import TextField from 'material-ui/TextField';
import * as Colors from '../../utils/Color';


const styles = {
    underlineStyle: {
        borderColor: Colors.grey
    },
    underlineFocusStyle: {
        borderColor: Colors.primary
    },
    floatingLabelStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    hintStyle: {
        fontWeight: 'bold',
        color: Colors.grey50
    },
    floatingLabelFocusStyle: {
        color: Colors.grey50,
        fontSize: '18px'
    }
};


class TextFields extends Component {
    render() {
        const { asyncError, name, floatingLabelText, hintText, arb, hide, onChange, onBlur, value, disabled } = this.props;
        const error = asyncError && asyncError[name];
        const options = {
            floatingLabelText,
            hintText,
            inputStyle: arb ? {direction: 'rtl'} : null,
            style: hide ? {display: 'none'} : null,
            errorText: error || this.props.error,
            fullWidth: true,
            name,
            onChange,
            onBlur,
            value,
            disabled
        };
        return (
            <TextField {...styles} {...options} className="text-field" />
        );
    }
}

const mapStateToProps = state => {
    return {
        asyncError: state.auth.error
    }
};


export default connect(mapStateToProps)( TextFields );



// WEBPACK FOOTER //
// ./src/components/UI/TextField-f.js